module.exports = __webpack_public_path__ + "static/img/BYD.2933690.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/BYD.png
// module id = 2rxX
// module chunks = 34